import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var orderRoute = [{
  path: "order/:status",
  name: "order",
  component: function component() {
    return import("./order.vue");
  }
}];